import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';

const SortIcon = ({ value = '' }) => {
  const down = value.startsWith('+');
  const top = value.startsWith('-');
  return (
    <div className="sort-icon">
      <div
        className={classNames('top', {
          'sort-icon--active': top,
        })}
      >
        <CaretUpOutlined />
      </div>
      <div
        className={classNames('down', {
          'sort-icon--active': down,
        })}
      >
        <CaretDownOutlined />
      </div>
    </div>
  );
};

export default SortIcon;
